import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_ORDERS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_ORDERS.STATE.ORDERS]: null,
  [LOT_ORDERS.STATE.LAST_ORDER]: null,
  [LOT_ORDERS.STATE.TRADE_RESULTS]: null,
  [LOT_ORDERS.STATE.TRADE_RESULTS_ORGANIZATIONS]: null
}

const actions = {
  async [LOT_ORDERS.ACTIONS.GET_ORDERS_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionId}/orders?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_ORDERS.MUTATIONS.GET_ORDERS_LIST, resp.data)
  },
  async [LOT_ORDERS.ACTIONS.GET_ORDER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionId}/orders/${model.orderId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_ORDERS.MUTATIONS.GET_ORDER, resp.data)
  },
  async [LOT_ORDERS.ACTIONS.GET_TRADE_RESULTS_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeResults?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_ORDERS.MUTATIONS.GET_TRADE_RESULTS_LIST, resp.data)
  },
  async [LOT_ORDERS.ACTIONS.GET_TRADE_RESULTS_ORGANIZATIONS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/tradeResults/organizations?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_ORDERS.MUTATIONS.GET_TRADE_RESULTS_ORGANIZATIONS, resp.data)
  },
  async [LOT_ORDERS.ACTIONS.ADD_ORDER] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionId}/orders`,
      model: model.order
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_ORDERS.ACTIONS.CHANGE_ORDER_STATUS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionId}/orders/${model.orderId}/status`,
      model: model.status
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_ORDERS.ACTIONS.CLEAR_ORDERS_LIST] ({ commit }) {
    commit(LOT_ORDERS.MUTATIONS.CLEAR_ORDERS_LIST)
  },
  async [LOT_ORDERS.ACTIONS.CLEAR_ORDER] ({ commit }) {
    commit(LOT_ORDERS.MUTATIONS.CLEAR_ORDER)
  },
  async [LOT_ORDERS.ACTIONS.CLEAR_TRADE_RESULTS_LIST] ({ commit }) {
    commit(LOT_ORDERS.MUTATIONS.CLEAR_TRADE_RESULTS_LIST)
  },
  async [LOT_ORDERS.ACTIONS.CLEAR_TRADE_RESULTS_ORGANIZATIONS] ({ commit }) {
    commit(LOT_ORDERS.MUTATIONS.CLEAR_TRADE_RESULTS_ORGANIZATIONS)
  },
  async [LOT_ORDERS.ACTIONS.ADD_ORDER_DIVISIBLE_VOLUME] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/sessions/${model.sessionId}/orders`,
      model: model.order
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  }
}

const mutations = {
  [LOT_ORDERS.MUTATIONS.GET_ORDERS_LIST] (state, orders) {
    state[LOT_ORDERS.STATE.ORDERS] = orders
  },
  [LOT_ORDERS.MUTATIONS.GET_ORDER] (state, order) {
    state[LOT_ORDERS.STATE.LAST_ORDER] = order
  },
  [LOT_ORDERS.MUTATIONS.GET_TRADE_RESULTS_LIST] (state, orders) {
    state[LOT_ORDERS.STATE.TRADE_RESULTS] = orders
  },
  [LOT_ORDERS.MUTATIONS.GET_TRADE_RESULTS_ORGANIZATIONS] (state, organizations) {
    state[LOT_ORDERS.STATE.TRADE_RESULTS_ORGANIZATIONS] = organizations
  },
  [LOT_ORDERS.MUTATIONS.CLEAR_ORDERS_LIST] (state) {
    state[LOT_ORDERS.STATE.ORDERS] = null
  },
  [LOT_ORDERS.MUTATIONS.CLEAR_ORDER] (state) {
    state[LOT_ORDERS.STATE.LAST_ORDER] = null
  },
  [LOT_ORDERS.MUTATIONS.CLEAR_TRADE_RESULTS_LIST] (state) {
    state[LOT_ORDERS.STATE.TRADE_RESULTS] = null
  },
  [LOT_ORDERS.MUTATIONS.CLEAR_TRADE_RESULTS_ORGANIZATIONS] (state) {
    state[LOT_ORDERS.STATE.TRADE_RESULTS_ORGANIZATIONS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
